<template>
  <div class="home">
    <div class="locale-changer">
      <button style="font-size: 14px" @click="toggleCTCS()">
        {{ $t('button.toggleCTCS') }}
      </button>
    </div>
    <div style="margin-top: 30px">{{ $t('homeTitle') }}</div>
    <div
      style="margin-top: 15px; margin-bottom: 15px; font-size: 14px"
      v-if="history.length > 0"
    >
      <span>{{ $t('input.recent') }}&nbsp;</span>
      <span
        v-for="(item, index) in history"
        :key="item.ts"
        @click="useHistory(index)"
        class="recent-name"
      >
        {{ showNameStr(item.name) }}&nbsp;
      </span>
    </div>
    <div class="input-section-wrapper">
      <div class="input-title">
        <label for="name">姓名</label>
      </div>
      <div
        class="birthday-input"
        style="display: inline-block; width: 250px; max-width: 85%"
      >
        <input
          type="text"
          id="name"
          name="name"
          style="
            width: 100%;
            margin: 0;
            padding: 0;
            border: 0;
            height: 100%;
            font-size: 30px;
            text-align: center;
          "
          v-model="name"
        />
      </div>
      <div class="input-title" style="margin-bottom: 0">
        <label for="gender">性别</label
        ><input
          type="radio"
          id="male"
          name="gender"
          value="1"
          v-model="gender"
          style="width: 24px; height: 24px"
        />
        <label for="male">男</label>
        <input
          type="radio"
          id="female"
          name="gender"
          value="2"
          v-model="gender"
          style="width: 24px; height: 24px"
        />
        <label for="female">女</label>
      </div>
    </div>
    <div class="input-section-wrapper">
      <div class="input-title">
        <label for="birthday-date">{{ $t('input.solarTime') }}</label>
      </div>
      <div
        class="birthday-input"
        @click="showModal = true"
        style="display: inline-block; width: 250px; max-width: 85%"
      >
        {{ currentYear }}-{{ currentMonth }}-{{ currentDay }}
      </div>
      <div class="input-title">
        <label for="birthday-time">{{ $t('input.watchTime') }}</label>
      </div>
      <div
        class="birthday-input"
        @click="showTimePickerModal = true"
        style="display: inline-block; width: 250px; max-width: 85%"
      >
        {{ String(currentHour).padStart(2, '0') }}
        :
        {{ String(currentMinute).padStart(2, '0') }}
      </div>
    </div>
    <div class="input-section-wrapper">
      <div class="input-title">
        <div>{{ $t('input.area0') }}</div>
      </div>
      <div class="area0">
        <div class="area0-item">
          <input
            type="radio"
            id="Asia/Taipei"
            name="area0"
            value="Asia/Taipei"
            v-model="area0"
            style="width: 18px; height: 18px"
          />
          <label for="Asia/Taipei">{{ $t('input.place.taiwan') }}</label>
        </div>
        <div class="area0-item">
          <input
            type="radio"
            id="Asia/Shanghai"
            name="area0"
            value="Asia/Shanghai"
            v-model="area0"
            style="width: 18px; height: 18px"
          />
          <label for="Asia/Shanghai">{{ $t('input.place.china') }}</label>
        </div>
        <div class="area0-item">
          <input
            type="radio"
            id="Asia/Hong_Kong"
            name="area0"
            value="Asia/Hong_Kong"
            v-model="area0"
            style="width: 18px; height: 18px"
          />
          <label for="Asia/Hong_Kong">{{ $t('input.place.hongkong') }}</label>
        </div>
        <div class="area0-item">
          <input
            type="radio"
            id="Asia/Macau"
            name="area0"
            value="Asia/Macau"
            v-model="area0"
            style="width: 18px; height: 18px"
          />
          <label for="Asia/Macau">{{ $t('input.place.macau') }}</label>
        </div>
        <div class="area0-item">
          <input
            type="radio"
            id="Asia/Kuala_Lumpur"
            name="area0"
            value="Asia/Kuala_Lumpur"
            v-model="area0"
            style="width: 18px; height: 18px"
          />
          <label for="Asia/Kuala_Lumpur">{{
            $t('input.place.malaysia')
          }}</label>
        </div>
        <div class="area0-item">
          <input
            type="radio"
            id="other"
            name="area0"
            value="other"
            v-model="area0"
            style="width: 18px; height: 18px"
          />
          <label for="other">{{ $t('input.place.other') }}</label>
        </div>
      </div>
      <!-- 其他區域選擇 -->
      <div style="width: 100%" v-if="area0 == 'other'">
        <div class="input-title">
          <label>{{ $t('input.area') }}</label>
        </div>
        <div
          style="width: 250px; max-width: 85%; margin: 0 auto; display: flex"
        >
          <select
            name="continent"
            id="continent"
            v-model="selectContinent"
            class="area-select timezone-select"
          >
            <option
              v-for="(item, index) in continentList"
              :key="index"
              :value="item"
            >
              {{ $t('continent.' + item + '_name') }}
            </option>
          </select>
        </div>
        <div class="input-title">
          <label>{{ $t('input.timezone') }}</label>
        </div>
        <div
          style="width: 250px; max-width: 85%; margin: 0 auto; display: flex"
        >
          <select
            name="timezone"
            id="timezone"
            v-model="timezone"
            class="area-select timezone-select"
          >
            <option
              v-for="(item, index) in timezoneList"
              :key="index"
              :value="item.timezone"
            >
              {{ item.UTC }} {{ $t('timezone.' + item.timezone + '_name') }}
            </option>
          </select>
        </div>
      </div>
      <!-- 其他區域選擇 END -->
      <!-- 中國區域選擇 -->
      <div
        v-else-if="area0 == 'Asia/Shanghai'"
        style="
          display: flex;
          justify-content: space-between;
          width: 250px;
          max-width: 85%;
          margin: 15px auto 0;
        "
      >
        <select
          name="area-level1"
          id="area-level1"
          v-model="selectAreaLevel1"
          class="area-select"
          style="max-width: calc(47% - 42px)"
        >
          <option value="-1">-----</option>
          <option
            v-for="(item, index) in areaLevel1"
            :key="index"
            :value="item.code"
          >
            {{ $t(item.name) }}
          </option>
        </select>
        <select
          name="area-level2"
          id="area-level2"
          v-model="selectAreaLevel2"
          class="area-select"
          style="max-width: calc(47% - 42px)"
        >
          <option value="-1">-----</option>
          <option
            v-for="(item, index) in areaLevel2.filter(
              (item) => item.parentCode == selectAreaLevel1
            )"
            :key="index"
            :value="item.code"
          >
            {{ $t(item.name) }}
          </option>
        </select>
      </div>
      <!-- 中國區域選擇 END -->
      <!-- 馬來西亞區域選擇 -->
      <div
        v-else-if="area0 == 'Asia/Kuala_Lumpur'"
        style="
          display: flex;
          justify-content: space-evenly;
          width: 250px;
          max-width: 85%;
          margin: 15px auto 0;
        "
      >
        <select
          name="area-level1"
          id="area-level1"
          v-model="selectAreaLevel1"
          class="area-select"
        >
          <option value="-1">-----</option>
          <option
            v-for="(item, index) in areaLevel1"
            :key="index"
            :value="item.code"
          >
            {{ $t(item.name) }}
          </option>
        </select>
      </div>
      <!-- 馬來西亞區域選擇 END -->
    </div>
    <!-- 聯絡資料填寫 -->
    <div class="input-section-wrapper" v-if="!hasContact">
      <div v-if="area0 == 'Asia/Shanghai'">
        <div class="input-title">
          <label for="phone">{{ $t('input.phone') }}</label>
        </div>
        <input
          type="number"
          id="phone"
          name="phone"
          style="
            width: 250px;
            max-width: 85%;
            margin: 0;
            padding: 0;
            border: 1px rgb(118, 118, 118) solid;
            font-size: 24px;
            text-align: center;
            line-height: 1.5;
            border-radius: 0;
            -webkit-appearance: none;
            appearance: none;
          "
          v-model="phone"
        />
      </div>
      <div v-else>
        <div class="input-title">
          <label for="email">{{ $t('input.email') }}</label>
        </div>
        <input
          type="text"
          id="email"
          name="email"
          style="
            width: 250px;
            max-width: 85%;
            margin: 0;
            padding: 0;
            border: 1px rgb(118, 118, 118) solid;
            font-size: 24px;
            text-align: center;
            line-height: 1.5;
            border-radius: 0;
            -webkit-appearance: none;
            appearance: none;
          "
          v-model="email"
        />
      </div>
    </div>
    <!-- 聯絡資料填寫 END -->
    <div v-if="!hasContact">
      <input
        type="checkbox"
        id="subscribe"
        name="subscribe"
        value="true"
        v-model="subscribe"
      /><label for="subscribe" style="font-size: 16px">{{
        $t('input.news')
      }}</label>
    </div>

    <div style="margin-top: 30px">
      <button @click="submit()" style="font-size: 30px; margin-bottom: 30px">
        {{ $t('button.calMingPan') }}
      </button>
    </div>
    <Teleport to="body">
      <!-- use the modal component, pass in the prop -->
      <date-picker-modal
        :show="showModal"
        :year="currentYear"
        :month="currentMonth"
        :day="currentDay"
        @modal-submit="modalSubmit"
        @close="showModal = false"
      >
      </date-picker-modal>
      <!-- use the modal component, pass in the prop -->
      <time-picker-modal
        :show="showTimePickerModal"
        :hour="currentHour"
        :minute="currentMinute"
        @modal-submit="timeModalSubmit"
        @close="showTimePickerModal = false"
      >
      </time-picker-modal>
    </Teleport>
  </div>
</template>
<script>
import moment from 'moment-timezone'

import DatePickerModal from '@/components/DatePickerModal.vue'
import TimePickerModal from '@/components/TimePickerModal.vue'

import {
  AREAS,
  HAS_PLACE_NAME_TIMEZONE,
  // USE_LEVEL,
  BASE_AREA,
} from '@/constant/china'
import { TIMEZONE, CONTINENT } from '@/constant/timezone'
import { CALLING_CODES } from '@/constant/calling-code'
import axios from 'axios'

const AREA0 = [
  'Asia/Taipei',
  'Asia/Shanghai',
  'Asia/Kuala_Lumpur',
  'Asia/Hong_Kong',
  'Asia/Macau',
]

const emailRule =
  /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/

const phoneRule = /^\d+$/

const EAST_MALAYSIA = ['60040000', '60050000', '60020000']
const EAST_MALAYSIA_TZ = 'Asia/Kuching'

export default {
  name: 'InputDataVue',
  data: function () {
    return {
      name: '',
      email: '',
      phone: '',
      contactType: 'email',
      currentYear: 1970,
      currentMonth: 7,
      currentDay: 15,
      currentHour: 12,
      currentMinute: 0,
      gender: '1',
      daylight: '0',
      selectAreaLevel1: '-1',
      selectAreaLevel2: '-1',
      selectAreaLevel3: '-1',
      showModal: false,
      showTimePickerModal: false,
      history: [],
      callingCode: CALLING_CODES,
      timezone: '',
      subscribe: true,
      selectContinent: 'asia',
      continentList: CONTINENT,
      area0: 'Asia/Shanghai',
      hasContact: false,
      longitude: 121,
    }
  },
  components: {
    DatePickerModal,
    TimePickerModal,
  },
  mounted: async function () {
    // 首先获取视窗高度，再乘以1%得到vh单位的值
    let vh = window.innerHeight * 0.01
    // 把--vh的值设置到文档的根元素中
    document.documentElement.style.setProperty('--vh', `${vh}px`)

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    this.timezone = timeZone

    if (AREA0.includes(this.timezone)) {
      this.area0 = this.timezone
    } else if (this.$i18n.locale == 'zh-TW') {
      this.area0 = 'Asia/Taipei'
    } else {
      this.area0 = 'Asia/Shanghai'
    }

    if (window.localStorage.getItem('user') !== null) {
      const user = JSON.parse(window.localStorage.getItem('user'))
      const date = moment.tz(user.birthday, 'YYYY/MM/DD HH:mm', 'Etc/GMT-8')

      this.currentYear = date.year()
      this.currentMonth = date.month() + 1
      this.currentDay = date.date()

      this.currentHour = date.hour()
      this.currentMinute = date.minute()

      this.gender = user.gender
      this.subscribe = user.subscribe

      // this.daylight = user.daylight || 0

      this.name = user.name
      this.email = user.email
      this.phone = user.phone
      if (this.email.search(emailRule) != -1 || phoneRule.test(this.phone)) {
        this.hasContact = true
      }

      this.timezone = user.timezone || this.timezone
      this.longitude = user.longitude

      if (AREA0.includes(this.timezone)) {
        this.area0 = user.timezone
      } else if (this.timezone == EAST_MALAYSIA_TZ) {
        this.area0 = 'Asia/Kuala_Lumpur'
        this.timezone = 'Asia/Kuala_Lumpur'
      } else {
        this.area0 = 'other'
      }

      try {
        this.selectContinent = TIMEZONE.find(
          (item) => item.timezone == this.timezone
        ).area
      } catch (error) {
        if (this.$i18n.locale == 'zh-TW') {
          this.timezone = 'Asia/Taipei'
        } else {
          this.timezone = 'Asia/Shanghai'
        }

        this.selectContinent = TIMEZONE.find(
          (item) => item.timezone == this.timezone
        ).area
      }

      const userLocation = user.selectPlace || '-1'
      if (userLocation != '-1') {
        const selectArea = AREAS.find((item) => item.code == userLocation)
        console.log(selectArea)
        if (selectArea.level == 2) {
          this.selectAreaLevel1 = AREAS.find(
            (item) => item.code == selectArea.parentCode
          ).code
          this.selectAreaLevel2 = selectArea.code
        } else {
          this.selectAreaLevel1 = selectArea.code
        }
      }
    }

    this.$watch('area0', () => {
      // this.email = ''
      // this.phone = ''
      if (this.area0 == 'other') {
        this.selectContinent = 'asia'
        this.timezone = this.timezoneList[0].timezone
      } else {
        this.timezone = this.area0
      }
    })

    this.$watch('selectAreaLevel1', () => {
      this.selectAreaLevel2 = '-1'
      if (this.selectAreaLevel1 != '-1') {
        this.longitude = Math.round(
          AREAS.find((item) => item.code == this.selectAreaLevel1).longitude
        )
      } else {
        this.longitude = Math.round(
          TIMEZONE.find((item) => item.timezone == this.timezone).longitude
        )
      }
    })

    this.$watch('selectAreaLevel2', () => {
      if (this.selectAreaLevel2 != '-1') {
        this.longitude = Math.round(
          AREAS.find((item) => item.code == this.selectAreaLevel2).longitude
        )
      }
    })

    this.$watch('selectContinent', () => {
      this.timezone = this.timezoneList[0].timezone
    })

    this.$watch('timezone', () => {
      try {
        this.longitude = Math.round(
          TIMEZONE.find((item) => item.timezone == this.timezone).longitude
        )
      } catch (e) {
        console.log(e)
      }
    })

    this.$watch('area0', () => {
      try {
        this.longitude = Math.round(
          TIMEZONE.find((item) => item.timezone == this.timezone).longitude
        )
      } catch (e) {
        console.log(e)
      }
      if (this.area0 == 'Asia/Shanghai') {
        this.selectAreaLevel1 = '110000'
        this.selectAreaLevel2 = '-1'
      } else if (this.area0 == 'Asia/Kuala_Lumpur') {
        this.selectAreaLevel1 = '60010000'
        this.selectAreaLevel2 = '-1'
      } else {
        this.selectAreaLevel1 = '-1'
        this.selectAreaLevel2 = '-1'
      }
    })

    this.history = JSON.parse(window.localStorage.getItem('history')).sort(
      (a, b) => b.ts - a.ts
    )
  },
  watch: {},
  computed: {
    user: function () {
      const birthday = moment.tz(
        this.birthdayDate +
          ' ' +
          String(this.currentHour).padStart(2, '0') +
          ':' +
          String(this.currentMinute).padStart(2, '0'),
        'YYYY-MM-DD HH:mm',
        'Etc/GMT-8'
      )

      const age = moment().tz('Etc/GMT-8').year() - birthday.year() + 1

      let location = this.selectAreaLevel3
      if (location == '-1') location = this.selectAreaLevel2
      if (location == '-1') location = this.selectAreaLevel1

      let tz = this.timezone
      if (EAST_MALAYSIA.includes(location)) {
        tz = 'Asia/Kuching'
      }

      return {
        name: this.name,
        birthday: birthday.format('YYYY/MM/DD HH:mm'),
        gender: this.gender,
        selectPlace: location,
        daylight: this.daylight,
        email: this.email,
        phone: this.phone,
        age,
        subscribe: this.subscribe,
        timezone: tz,
        longitude: this.longitude,
      }
    },
    birthdayDate: function () {
      const d =
        this.currentYear + '-' + this.currentMonth + '-' + this.currentDay
      return d
    },
    isClass: function () {
      return process.env.VUE_APP_USE_STARS === 'CLASS'
    },
    areaLevel1: function () {
      const tz = this.timezone
      return AREAS.filter(function (item) {
        return item.level == 1 && item.parentCode == BASE_AREA[tz]
      })
    },
    areaLevel2: function () {
      return AREAS.filter(function (item) {
        return item.level == 2 && item.longitude
      })
    },
    areaLevel3: function () {
      return AREAS.filter(function (item) {
        return item.level == 3
      })
    },
    areaName: function () {
      if (this.user.selectPlace != '-1') {
        const location =
          AREAS.find((item) => item.code == this.user.selectPlace) || 110000
        if (location.level == 3) {
          const level2 = this.areaLevel2.find(
            (item) => item.code == location.parentCode
          )
          const level1 = this.areaLevel1.find(
            (item) => item.code == level2.parentCode
          )
          return (
            this.$i18n.t(level1.name) +
            '-' +
            this.$i18n.t(level2.name) +
            '-' +
            this.$i18n.t(location.name)
          )
        } else if (location.level == 2) {
          const level1 = this.areaLevel1.find(
            (item) => item.code == location.parentCode
          )
          return this.$i18n.t(level1.name) + '-' + this.$i18n.t(location.name)
        }
        return this.$i18n.t(location.name)
      } else {
        return ''
      }
    },
    timezoneGroup: function () {
      return Object.groupBy(TIMEZONE, ({ area }) => area)
    },
    timezoneList: function () {
      const tz = this.timezoneGroup[this.selectContinent]
      const ftz = tz.filter((item) => !AREA0.includes(item.timezone))
      ftz.sort((a, b) => a.UTC - b.UTC)
      return ftz
    },
    showPlaceSelect: function () {
      return HAS_PLACE_NAME_TIMEZONE.includes(this.timezone)
    },
  },
  methods: {
    submit: function () {
      if (this.email.search(emailRule) != -1 || phoneRule.test(this.phone)) {
        if (this.name == '') {
          alert(this.$t('no-name'))
        } else if (this.longitude > 180 || this.longitude < -180) {
          alert(this.$t('longitude-error'))
          if (this.selectAreaLevel2 != '-1') {
            this.longitude = Math.round(
              AREAS.find((item) => item.code == this.selectAreaLevel2).longitude
            )
          } else if (this.selectAreaLevel1 != '-1') {
            this.longitude = Math.round(
              AREAS.find((item) => item.code == this.selectAreaLevel1).longitude
            )
          } else {
            this.longitude = Math.round(
              TIMEZONE.find((item) => item.timezone == this.timezone).longitude
            )
          }
        } else {
          window.localStorage.setItem('user', JSON.stringify(this.user))

          let isSame = false
          this.history.forEach((item) => {
            const { ts, ...newObj } = item // eslint-disable-line no-unused-vars
            if (isEqual(this.user, newObj)) {
              console.log('same')
              isSame = true
            }
          })

          if (!isSame) {
            if (this.history.length >= 3) {
              this.history = this.history.slice(0, 2)
            }
            this.history.push({ ...this.user, ts: Date.now() })
            this.history.sort((a, b) => b.ts - a.ts)
            window.localStorage.setItem('history', JSON.stringify(this.history))
          }
          window.localStorage.setItem('locale', this.$i18n.locale)
          this.sendLog()

          this.$router.push({ name: 'Home' })
        }
      } else if (this.area0 != 'Asia/Shanghai' && !emailRule.test(this.email)) {
        alert(this.$t('no-email'))
      } else if (this.area0 == 'Asia/Shanghai' && !phoneRule.test(this.phone)) {
        alert(this.$t('no-phone'))
      } else {
        alert(this.$t('no-email'))
      }
    },
    useHistory: function (index) {
      window.localStorage.setItem('user', JSON.stringify(this.history[index]))
      this.$router.push({ name: 'Home' })
    },
    sendLog: function () {
      let location = AREAS.find((item) => item.code == this.selectArea)
      if (!location) {
        this.selectArea = 110000
        location = AREAS.find((item) => item.code == this.selectArea)
      }

      const payload = {
        name: this.user.name,
        gender: this.user.gender,
        email: this.email,
        phone: this.phone,
        birthday: this.user.birthday,
        code: this.user.location,
        timezone: this.user.timezone,
        longitude: this.user.longitude,
        daylight: this.user.daylight,
        subscribe: this.subscribe,
        location: this.areaName,
      }

      axios.post('https://api.taotaoxi.cn/ming-pan/log', payload, {
        headers: {
          'Content-Type': 'application/json',
          'x-ca-stage': 'TEST',
        },
      })
    },
    modalSubmit: function (year, month, day) {
      this.currentYear = year
      this.currentMonth = month
      this.currentDay = day
    },
    timeModalSubmit: function (hour, minute) {
      this.currentHour = hour
      this.currentMinute = minute
    },
    toggleCTCS: function () {
      if (this.$i18n.locale == 'zh-TW') {
        this.$i18n.locale = 'zh-CN'
        document.title = this.$i18n.t('page.title')
      } else {
        this.$i18n.locale = 'zh-TW'
        document.title = this.$i18n.t('page.title')
      }
    },
    showNameStr: function (name) {
      if (isString(name)) {
        if (name.length > 5) return name.slice(0, 5)
        else return name
      } else {
        return ''
      }
    },
  },
}

function isEqual(obj1, obj2) {
  var props1 = Object.getOwnPropertyNames(obj1)
  var props2 = Object.getOwnPropertyNames(obj2)
  if (props1.length != props2.length) {
    return false
  }
  for (var i = 0; i < props1.length; i++) {
    let val1 = obj1[props1[i]]
    let val2 = obj2[props1[i]]
    let isObjects = isObject(val1) && isObject(val2)
    if ((isObjects && !isEqual(val1, val2)) || (!isObjects && val1 !== val2)) {
      return false
    }
  }
  return true
}
function isObject(object) {
  return object != null && typeof object === 'object'
}

function isString(value) {
  return typeof value === 'string' || value instanceof String
}
</script>
<style scoped>
.home {
  min-height: 100vh;
  /* height: calc(var(--vh, 1vh) * 100); */
  overflow: hidden;
  padding-top: 40px;
  padding-bottom: 40px;
  display: flex;
  font-size: 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.recent-name {
  color: blue;
  cursor: pointer;
}
.recent-name:active {
  color: #5500ff;
}
.input-section-wrapper {
  width: 100%;
  margin: 15px 0;
}
.input-title {
  margin: 15px 0 15px;
}
.area0 {
  font-size: 24px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 250px;
  max-width: 85%;
  margin: 0 auto;
}
.area0-item {
  width: 50%;
  text-align: left;
}
.timezone-select {
  text-align: center;
  font-size: 30px;
  width: 100%;
}
.area-select {
  all: unset; /* 清除框架樣式 */
  font-size: 24px;
  flex: 1;
  height: 1.4em;
  line-height: 1.4em;
  border: 1px rgb(118, 118, 118) solid;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 2px center;
  text-align: left;
  text-align-last: left;
  padding: 0 38px 0 5px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
}
.birthday-input {
  border: 1px solid rgb(118, 118, 118);
  height: 1.2em;
  width: 85%;
  margin: 0 auto;
  overflow: hidden;
}
.locale-changer {
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
